require('intersection-observer')

import appUtils from './app_utils'

import { gsap } from "gsap"
import { Observer } from "gsap/Observer"
gsap.registerPlugin(Observer);

let snaptoTargets = []
const snaptoObserverOptions = {
 // rootMargin: '0px',
 // threshold: 0.5 // [0, 0.5, 1]
 rootMargin: '-50% 0px -50% 0px',
 threshold: 0.0
}

const body = document.querySelector('body')
const snaptoObserverCallback = (entries, snaptoObserver) => {
  entries.forEach(entry => {
    //if (entry.intersectionRatio < 0.2) {
    if (entry.isIntersecting) {
      entry.target.classList.add("snapto-view")
      $(entry.target).trigger('snapto-view--in')
    } else {
      entry.target.classList.remove("snapto-view")
      $(entry.target).trigger('snapto-view--out')
    }
  });
};

// https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/IntersectionObserver
// https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/observe
// https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/unobserve
// https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/disconnect
const snaptoObserver = new IntersectionObserver(snaptoObserverCallback, snaptoObserverOptions);

const init = function() {
  snaptoTargets = document.querySelectorAll("[data-snapto]")
  if (snaptoTargets.length) {
    snaptoTargets.forEach(target => snaptoObserver.observe(target))
  }
}

const destroy = function() {
  if (snaptoTargets.length) {
    snaptoTargets.forEach((target) => {
      snaptoObserver.unobserve(target)
    })
  }
}

export default {init, destroy}

if (appUtils.scrollTriggerCustomResizeHandler) {
  Observer.create(appUtils.scrollTriggerObeserverParams)
}